<template>
  <div v-if="poster" class="u-p-20">
    <div class="title u-font-20 font-bold text-center">{{ $t(poster.title) }}</div>
    <div class="title u-font-20 font-bold pl-5">{{ poster.subTitle }}</div>
    <div class="time text-grey u-m-b-15 u-m-t-15">{{ poster.publishTime }}</div>
    <div class="rich-text" v-html="getFileViewContent(poster.description||poster.content)" />
  </div>
</template>

<script>
import { getNoticeInfo } from '@/api/sys/info'

export default {
  name: 'messageForm',
  props: {
    id: {}
  },
  data() {
    return {
      posterId: null,
      poster: null
    }
  },
  computed: {
  },
  created() {
    this.posterId = this.$route.params.id || this.id
    this.getDetail()
  },
  methods: {
    getDetail() {
      getNoticeInfo(this.posterId).then(res => {
        this.poster = res && res.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
